const isFunction = (value: any): value is Function => typeof value === `function`;

export const runIfFn = <T, U>(valueOrFn: T | ((...fnArgs: Array<U>) => T), ...args: Array<U>): T => {
  return isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
};
